import styled from 'styled-components';

export const FixedContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
`;


// WEBPACK FOOTER //
// src/app/src/components/StickyContainer/StickyContainer.s.ts